import Counters from './Counters';
import CrayonStroke from './CrayonStroke';
import DidYouKnow from './DidYouKnow';
import FlipCard from './FlipCard';
import KnowMyNumbers from './KnowMyNumbers';
import MatchItTrashIt from './MatchItTrashIt';
import PuzzlePieces from './PuzzlePieces';
import TagBags from './TagBags';
import VoiceRecorder from './VoiceRecorder';
import WordRepeater from './WordRepeater';
import WallCard from './WallCard';
import StartingSound from './StartingSound';

export default {
  Counters,
  CrayonStroke,
  DidYouKnow,
  FlipCard,
  KnowMyNumbers,
  MatchItTrashIt,
  PuzzlePieces,
  StartingSound,
  SoundRecorder: VoiceRecorder,
  SoundRepeater: WordRepeater,
  TagBags,
  VoiceRecorder,
  WallCard,
  VoiceRepeater: WordRepeater,
  WordRecorder: VoiceRecorder,
  WordRepeater
};
